export default "__VITE_ASSET__c6d791c6__"